import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = ['¿Cómo recibo el STRETCHING RESUELTO después de comprar?', '¿Sirve para profes con poca experiencia o solo para los avanzados?', '¿Es editable? ¿Puedo modificarlo?', '¿Los 6 bonos están en las dos ofertas?', '¿Sirve si doy clases individuales o solo para grupos?', '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?', '¿Qué diferencia tiene con otros materiales de Stretching?', '¿Por qué elegir el STRETCHING RESUELTO + Cuerpo Seguro Pro y no el estándar?', '¿Tiene garantía real?'];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <Section className="bg-brand-dark" data-id="element-140">
      <div className="max-w-3xl mx-auto" data-id="element-141">
        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-6 md:mb-10 text-center" data-id="element-142">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-3" data-id="element-143">
          {faqs.map((question, i) => <div key={i} className="bg-brand-light border border-white/5 rounded-lg overflow-hidden" data-id="element-144">
              <button onClick={() => toggleFAQ(i)} className="w-full text-left p-4 md:p-5 flex items-center justify-between focus:outline-none" data-id="element-145">
                <span className="font-medium text-white text-sm md:text-base pr-6" data-id="element-146">
                  {question}
                </span>
                <ChevronDown className={`w-4 h-4 text-brand-accent transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-147" />
              </button>

              <AnimatePresence data-id="element-148">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-149">
                    <div className="px-4 pb-4 md:px-5 md:pb-5 text-gray-400 text-sm" data-id="element-150">
                      <p data-id="element-151">
                        Esta es una respuesta de ejemplo para la pregunta. El
                        material está diseñado para resolver todas tus dudas y
                        darte herramientas prácticas e inmediatas para tus
                        clases de stretching.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}